// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".agree-protocol-agree-protocol-46220{color:var(--color-gray-9);margin-bottom:24px}.agree-protocol-agree-protocol-46220>span{margin-left:8px}.agree-protocol-agree-protocol-46220 .ant-checkbox-checked .ant-checkbox-inner{background-color:var(--theme-primary-color)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"agree-protocol": "agree-protocol-agree-protocol-46220",
	"agreeProtocol": "agree-protocol-agree-protocol-46220"
};
export default ___CSS_LOADER_EXPORT___;
